import { FormControl } from 'baseui/form-control'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInput/useMeterInput'
import PceSearchButton from '@/containers/SubscriptionFormPageNew/Components/GasMeter/PceSearch/PceSearchButton'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'

const MeterInput = () => {
  const {
    meterIdOnBlurHandler,
    meterSerialOnBlurHandler,
    pceNo,
    meterSerialNumber,
    showMeterSerialNumber,
    isEditable,
    lastSentDate,
    meterStatus,
    showPceSearchButton,
    meterIdLabelKey,
    errors,
    t,
  } = useMeterInput()

  return (
    <>
      <FormControl error={getError('meter_id_gas', errors)}>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pceNo}
            label={pceNo ? t(meterIdLabelKey) : ''}
            placeholder={t('subscriptionForm:pce_module.meter_id.placeholder')}
            status={meterStatus}
            endEnhancer={<CopyEndEnhancer value={pceNo} />}
            button={<PceSearchButton hidden={!showPceSearchButton} />}
          />
        </>
      </FormControl>
      <SDFormControl hidden={!showMeterSerialNumber}>
        <SDInput
          disabled={isEditable === false || lastSentDate}
          onBlur={value => meterSerialOnBlurHandler(value)}
          currentValue={meterSerialNumber}
          label={meterSerialNumber ? t('subscriptionForm:pce_module.meter_id.label') : ''}
          placeholder={t('subscriptionForm:pce_module.meter_id.placeholder')}
          endEnhancer={<CopyEndEnhancer value={meterSerialNumber} />}
        />
      </SDFormControl>
    </>
  )
}

export default MeterInput
